import * as React from 'react';
import { UitkButtonSize, UitkPrimaryFloatingButton } from 'uitk-react-button';
import { ILocalization } from 'bernie-l10n';
import { UitkScrim, UitkScrimType } from 'uitk-react-scrim';
import { ClickTracker } from 'bernie-analytics';
const UitkPrimaryFloatingButtonTracked = ClickTracker(UitkPrimaryFloatingButton);

export interface HoldingAreaActionsProps {
  goToCheckout: () => void;
  l10n: ILocalization;
  isAllSoldOut: () => boolean;
}

export const HoldingAreaActions = ({ goToCheckout, l10n, isAllSoldOut }: HoldingAreaActionsProps) => (
  <UitkScrim type={UitkScrimType.BUTTON}>
    <UitkPrimaryFloatingButtonTracked
      className="uitk-cell"
      disabled={isAllSoldOut()}
      size={UitkButtonSize.LARGE}
      text={l10n.formatText('multiProperty.playback.continueToCheckout')}
      onClick={goToCheckout}
      rfrr="MultiProp.Checkout"
      linkName="MultiProp Checkout"
    />
  </UitkScrim>
);
